// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3jHLu","actions":"GroupTable_actions__3klxy","deleteModalFooter":"GroupTable_deleteModalFooter__g3Lb5"};